import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const resendLabel = {
  name: "resendLabel" as const,
  input: z.object({
    returnId: zExt.objectId(),
    emailOverride: z.string().optional(),
    /** The merchant checked the carrier and asks to book an unconfirmed collection again. */
    confirmCollectionRebook: z.boolean().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string().optional(),
    /** Set, with success false, when an unconfirmed collection needs the merchant to confirm a rebook. */
    collectionRebookReferences: z.array(z.string()).optional(),
  }),
};
